// extracted by mini-css-extract-plugin
export var circle = "_2h-2";
export var icon = "_2h-a";
export var iconHighlight = "_2h-0";
export var lg = "_2h-8";
export var md = "_2h-7";
export var outline = "_2h-4";
export var sm = "_2h-6";
export var square = "_2h-1";
export var xl = "_2h-9";
export var xs = "_2h-5";
export var xxs = "_2h-3";